<div class="header">
    <div class="header-navigation">
        <button mat-icon-button (click)="menuClick()">
            <mat-icon>menu</mat-icon>
        </button>
        <a href="/">
            <div class="header-brand">
                <div class="brand-logo">
                    <img src="../../assets/images/viessmann-white.svg" alt="Viessmann Logo" />
                </div>
                <div class="brand-title">
                    {{ environment.app.title }}
                </div>
            </div></a
        >
    </div>
    <div class="header-toolbar">
        <vih-app-switcher></vih-app-switcher>
        <vih-login [appManagesAuthentication]="true" [authenticated]="authenticated$"></vih-login>
    </div>
</div>
